import { Observable } from 'rxjs';
import { StorageParameters } from '../storage.service';
import { ApiBase } from './api.base';
import { AccountingReport } from '@admin-shared/models/accounting-report';


export class AccountingReportApi extends ApiBase {
  model = 'accounting-report';

  public getFolders(foundationId: string): Observable<AccountingReport[]> {
    return this.http.get<AccountingReport[]>(
      this.buildUrl('folders', foundationId),
      {
        headers: this.setHeaders({
          'Authorization': this.getStorage().getItem(StorageParameters.AccessTokenId)
        })
      },
    );
  }

  public getReports(folderId: string): Observable<AccountingReport[]> {
    return this.http.get<AccountingReport[]>(
      this.buildUrl(folderId),
      {
        headers: this.setHeaders({
          'Authorization': this.getStorage().getItem(StorageParameters.AccessTokenId)
        })
      },
    );
  }

  public createAccountingReport(accountingReport: AccountingReport): Observable<AccountingReport> {
    return this.http.post<AccountingReport>(
      this.buildUrl(),
      accountingReport,
      {
        headers: this.setHeaders({
          'Authorization': this.getStorage().getItem(StorageParameters.AccessTokenId)
        })
      },
    );
  }

  public patchAccountingReport(accountingReport: AccountingReport): Observable<AccountingReport> {
    return this.http.patch<AccountingReport>(
      this.buildUrl(accountingReport.id!),
      accountingReport,
      {
        headers: this.setHeaders({
          'Authorization': this.getStorage().getItem(StorageParameters.AccessTokenId)
        })
      },
    );
  }

  public deleteAccountingReport(id: string): Observable<AccountingReport> {
    return this.http.delete<AccountingReport>(
      this.buildUrl(id),
      {
        headers: this.setHeaders({
          'Authorization': this.getStorage().getItem(StorageParameters.AccessTokenId)
        })
      },
    );
  }
}
